import Image from 'next/image'
import { useRouter } from 'next/router'
import { useSurveyTranslations } from '@creativegs/pipe-toolkit/utils/translation'

import { localeHasHelpdeskLink } from 'utils/localeHelper'

function LandingFooter(): JSX.Element {
  const { t } = useSurveyTranslations('0-start-test')
  const router = useRouter()
  const helpdeskLink = localeHasHelpdeskLink(router.locale)

  return (
    <footer>
      <div className="flex justify-center sm:justify-between -mt-12">
        <div className="relative">
          <div className="absolute -top-24 sm:top-4 xl:top-0 -right-10 sm:right-auto sm:left-0 md:-left-14 xl:-left-64 w-40 h-52 self-end z-10">
            <Image
              layout="fill"
              objectFit="cover"
              src="/assets/o_series/landing/avocado-slices.png"
            />
          </div>
        </div>
        <p className="text-white leading-snug	text-center mb-10 max-w-xs sm:max-w-xl">
          {t('service_supported')}
        </p>
        <div />
      </div>
      <h3 className="text-silver text-center font-bold mb-4 max-w-xl mx-auto">
        {t('contacts')}
      </h3>
      <p className="text-silver text-center mb-10 max-w-xl mx-auto whitespace-pre-wrap">
        {t('support_works')}
      </p>
      <p className="text-silver text-center mb-10 max-w-xl mx-auto">
        {t('company_info')}
      </p>
      {/* eslint-disable-next-line react/jsx-no-target-blank */}
      <a
        href={helpdeskLink || `/${router.locale}/terms-of-service`}
        target="_blank"
        className="block link text-center mb-7 active:text-green-500"
      >
        {t('terms_of_service')}
      </a>
      {/* eslint-disable-next-line react/jsx-no-target-blank */}
      <a
        href={helpdeskLink || `/${router.locale}/privacy-policy`}
        target="_blank"
        className="block link text-center mb-7 active:text-green-500"
      >
        {t('privacy_policy')}
      </a>
      {/* eslint-disable-next-line react/jsx-no-target-blank */}
      <a
        href={helpdeskLink || `/${router.locale}/cookie-policy`}
        target="_blank"
        className="block link text-center mb-7 active:text-green-500"
      >
        {t('cookie_policy')}
      </a>
      <p className="text-silver text-center max-w-lg mx-auto">{t('results')}</p>
    </footer>
  )
}

export default LandingFooter
